module.exports = __webpack_public_path__ + "img/setting.98733607.svg";